import styled from 'styled-components';
import { Paragraph, Button, Icon } from 'components';

export const FileName = styled(Paragraph)`
  margin-left: ${props => props.theme.spacing.small};
  margin-right: ${props => props.theme.spacing.small};
`;

export const InlineButton = styled(Button)`
  margin-left: ${props => props.theme.spacing.medium};
`;

export const UploadRowsWrapper = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
  margin: 5px;
`;

export const UploadRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${props => props.theme.spacing.default};
  margin-left: ${props => props.theme.spacing.default};
  margin-right: ${props => props.theme.spacing.default};
`;

export const InfoIcon = styled(Icon)`
  margin-left: ${props => props.theme.spacing.small};
  color: ${props => props.theme.color.wfBlue};
  position: relative;
  bottom: 5px;
`;
